import { OctHeaderWrapper } from '@oceantech/oceantech-ui';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../app/modules/auth';
import { reInitMenu } from '../helpers';
import {
	ActivityDrawer,
	DrawerMessenger,
	InviteUsers,
	ThemeModeProvider,
	UpgradePlan,
} from '../partials';
import { Content } from './components/content';
import { ScrollTop } from './components/scroll-top';
import { ToolbarWrapper } from './components/toolbar';
import { PageDataProvider } from './core';
import { listModule } from '../../app/pages/Homepage/constant';
import {localStorageItem} from "../../app/modules/utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../../app/modules/auth/core/_consts";

const MasterLayout = () => {
	const location = useLocation();
	const { logout } = useAuth();
  const qlclMenu = localStorageItem.get(KEY_LOCALSTORAGE.ID_TOKEN_DECODE)?.["menus"]?.["oceantech-qlcl-server"] || [];
  const listMenu = qlclMenu[0]?.subs || [];

	useEffect(() => {
		reInitMenu();
	}, [location.key]);

	return (
		<PageDataProvider>
			<ThemeModeProvider>
				<div className="d-flex flex-column flex-root app-root" id="kt_app_root">
					<div className="app-page flex-column flex-column-fluid" id="kt_app_page">
						<OctHeaderWrapper
							// menuConfigurationKeys={
							// 	process.env.REACT_APP_SSO_CLIENT_ID === 'oceantech-emr-client'
							// 		? MENU_CONFIG_EMR
							// 		: MENU_CONFIG_INPATIENT
							// }
							// menuOptions={listModule}
							menuOptions={listMenu}
							hasCache
							onLogout={logout}
						/>
						<div className="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
							<div className="app-main flex-column flex-row-fluid" id="kt_app_main">
								<div className="d-flex flex-column flex-column-fluid p-0">
									<ToolbarWrapper />
									<Content>
										<Outlet />
									</Content>
								</div>
								{/* <FooterWrapper /> */}
							</div>
						</div>
					</div>
				</div>

				{/* begin:: Drawers */}
				<ActivityDrawer />
				{/* <RightToolbar /> */}
				<DrawerMessenger />
				{/* end:: Drawers */}

				{/* begin:: Modals */}
				<InviteUsers />
				<UpgradePlan />
				{/* end:: Modals */}
				<ScrollTop />
			</ThemeModeProvider>
		</PageDataProvider>
	);
};

export { MasterLayout };
